/*
* @描述: 表单设置页面
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025-02-19 16:22:28
*/
<template>
    <div class="form-set-control-wrap">
        <div class="form-set-control-top">
            <div class="form-set-control-top_return">
                <span class="back-icon" @click="handleClickReturn"><i class="el-icon-arrow-left"></i>返回</span>
                <span class="back-title">工单表单编辑</span>
            </div>
            <div class="form-set-control-top_right">
                <el-button plain size="small" type="primary" @click="handleClickCustomFormReview">预览
                </el-button>
                <el-button size="small" type="primary" @click="handleClickCustomFormPublish">发布</el-button>
            </div>
        </div>
        <div class="form-set-control-content">
            <CustomFormSite ref="customFormSite"
                            :can_set_show_rules="true"
                            :field_form="'workorders'"
                            :field_form_desc="'点击可对各字段单独设置，按住可拖动排序字段位置'"
                            :field_form_title="'表单预览区'"
                            :is_form_module="false"
                            :publish_btn_show="false"
                            :review_btn_show="false"
                            :review_form_type_list="reviewFormTypeList"
                            is_two_column
                            @submit-fields="submitFields"/>
        </div>
    </div>
</template>
<script>
    import CustomFormSite from "@/components/pComponents/CustomFormSite";
    import {saveFormFields} from "@/api";

    export default {
        name: "workOrderFormSet",
        data() {
            return {
                reviewFormTypeList: [
                    {
                        title: "电脑端",
                        value: "pc",
                        form_title: "新增商机",
                        form_desc: "模拟真实新增工单页面效果，预览中填写的数据系统不会保存，有些控件如附件、图片、收付款账户、发票不支持在预览中操作",
                    },
                    {
                        title: "移动端",
                        value: "mobile",
                        form_title: "新增商机",
                        form_desc: "模拟真实新增工单页面效果，预览中填写的数据系统不会保存，有些控件如附件、图片、收付款账户、发票不支持在预览中操作",
                    },
                ],
                fieldsData: {},
                submitFlag: false,
            }
        },
        components: {CustomFormSite},
        created() {
        },
        mounted() {
        },
        methods: {
            handleClickReturn() {
                this.$router.go(-1);
            },

            handleClickCustomFormReview() {
                this.$refs.customFormSite.handleClickReview()
            },

            handleClickCustomFormPublish() {
                this.$refs.customFormSite.handleClickPublish()
                if (this.submitFlag) {
                    this.$refs.customFormSite.btnDisabled = true;
                    saveFormFields(this.fieldsData).then((res) => {
                        if (res.code === 200) {
                            this.$message.success("设置成功");
                        } else {
                            this.$message.error(res.message);
                        }
                        this.$refs.customFormSite.btnDisabled = false;
                    });
                }
            },

            submitFields(data) {
                this.submitFlag = false;
                if (data && data.field_list) {
                    this.submitFlag = true;
                }
                this.fieldsData = data;
            }
        },
    }
</script>
<style lang="scss" scoped>

</style>